import React from 'react';

import { getInsightIcon, INSIGHT_PROCESSORS_MAP } from '~/components/Claim/Insights/InsightsHelper';
import { Insight } from '~/components/Claim/Insights/types';
import { MarkdownSection } from '~/core/atoms/MarkdownSection';
import SidePanel from '~/core/molecules/SidePanel';

interface InsightsSidePanelProps {
  insight: Insight;
  onClose: () => void;
  className?: string;
}

export const InsightSidePanel: React.FC<InsightsSidePanelProps> = ({ insight, onClose, className }) => {
  const IconComponent = getInsightIcon(insight);
  const processedContent = INSIGHT_PROCESSORS_MAP[insight.key || '']?.(insight) || insight.content;

  return (
    <SidePanel
      icon={
        <div className="rounded-lg bg-pink-100 p-8">
          <IconComponent size={16} className="shrink-0 text-pink-600" />
        </div>
      }
      title={insight.title}
      content={<MarkdownSection markdown={processedContent} />}
      onClose={onClose}
      className={className}
    />
  );
};

export default InsightSidePanel;
